module.exports = __webpack_public_path__ + "media/images/recruit-abc113a8a23c96e68666a12dcb5aa074.jpg";